<template>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>

    <!-------------------------------------------------------------------->
    <!-- action -->
    <!-------------------------------------------------------------------->

    <el-col :xs="8" :sm="8" :lg="8">
      <el-button type="normal" @click.prevent="goBack" class="ml-20" circle>
        <i class="el-icon-d-arrow-left"> </i>
      </el-button>
    </el-col>
    <el-col :xs="16" :sm="16" :lg="16" class="text-right">
    
      <el-button v-if="job.jobInfo.alreadySigned === 'no'" type="primary" @click.prevent="handleSign" class="mr-20">簽核 <i
          class="el-icon-s-claim"></i></el-button>

      <template v-if="job.todoInfo.status === 'close'">
        <el-popconfirm
          confirm-button-text="確定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="確定作廢此筆資料嗎?"
          @confirm="handleInvalid(job.todoInfo.id)"
        >
          <el-button size="mini" type="danger" slot="reference" class="mr-10">作廢此單</el-button>
        </el-popconfirm>
      </template>
          
      <el-tag v-if="job.jobInfo.alreadySigned === 'yes'" type="warning" class="mr-20">已簽核</el-tag>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- form -->
    <!-------------------------------------------------------------------->

    <!--    基本資料-->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main>
        <el-card class="box-card mycard">
          <div slot="header" class="clearfix">
            <span>基本資料</span>
          </div>
          <div>
            <el-form class="myform"　>
              <el-row>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="人員：">
                    {{job.todoInfo.userObj.username}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="標題：">
                    {{job.todoInfo.title}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="報表日期：">
                    {{job.todoInfo.startDate | fmtDate}}
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="24" :md="8">
                  <el-form-item label="請領單編號：">
                    {{job.todoInfo.reqPayNo}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-card>
      </el-main>
    </el-col>

   
    <!--    工作項目資料 -->
    <el-col :xs="24" :sm="24" :lg="24" class="mt-20">
      <el-main class="mymain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>請領項目</span>
          </div>
          <div>

            <el-table :data="job.reqItemHistory" empty-text="無資料" stripe　:default-expand-all="true">
              
              <el-table-column label="項次">
                  <template slot-scope="scope">
                    {{scope.$index+1}}.
                  </template>
              </el-table-column>
              <el-table-column label="類型" prop="itemType">
              </el-table-column>
              <el-table-column label="名稱" prop="itemName">
              </el-table-column>
              <el-table-column label="請領數" prop="itemQty"></el-table-column>
              <!-- 

              <el-table-column label="項次" width="50">
                  <template slot-scope="scope">{{scope.$index+1}}</template>
              </el-table-column>
              <el-table-column label="用品名稱">
                <template slot-scope="scope">
                  <p class="mt-10">({{scope.row.itemType}}) {{scope.row.itemName}}</p>
                </template>
              </el-table-column>
              <el-table-column label="請領數量" prop="itemQty" width="80">
              </el-table-column> -->
            </el-table>
            
          </div>
        </el-card>
      </el-main>
    </el-col>


    <!--    簽核紀錄-->
    <el-col :xs="24" :sm="24" :lg="24" v-if="job.jobInfo.status !== 'draft'" class="mt-20" >
      <el-main class="mymain">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>簽核紀錄</span>
          </div>
          <div>
            <el-table :data="job.signoffHistory" empty-text="無資料" stripe :default-expand-all="true">
                <el-table-column label="簽核時間" prop="updatedAt" width="150">
                  <template slot-scope="scope">
                    <p>{{ scope.row.updatedAt | fmtDateTime }}</p>
                  </template>
                </el-table-column>

                <el-table-column label="簽核人員" width="100">
                  <template slot-scope="scope">
                    <p>{{ scope.row.signerObj.username }}</p>
                  </template>
                </el-table-column>

                <el-table-column label="結果" prop="signResult">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.signResult === 'N' || scope.row.signResult === 'invalid'" type="danger">{{ scope.row.signResult | signResult }}</el-tag>
                    <el-tag v-else>{{ scope.row.signResult | signResult }}</el-tag>
                  </template>
                </el-table-column>

                <el-table-column label="" type="expand" width="30">
                    <template slot-scope="scope">
                      <p class="mt-10 ml-10">簽核備註 : {{ scope.row.notes }}</p>
                    </template>
                  </el-table-column>

                  <el-table-column>
                  </el-table-column>
              </el-table>

          </div>
        </el-card>
      </el-main>
    </el-col>


    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->

     <el-dialog title="簽核資訊"
               :visible.sync="signoff.dialog"
               :width="dw">

      <el-form :model="job.jobInfo" ref="signForm" :rules="signoff.rules">
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="簽核選擇" prop="signResult">
              <el-radio v-model="job.jobInfo.signResult" label="Y">同意</el-radio>
              <el-radio v-model="job.jobInfo.signResult" label="N">退回</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item label="備註" prop="notes">
              <el-input rows="5" type="textarea" v-model="job.jobInfo.notes" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="signoff.dialog = false">取 消</el-button>
        <el-button type="primary" @click="sendSignoff('signForm')">確 定</el-button>
      </div>
    </el-dialog>



        <el-dialog title="附件圖"
                   :visible.sync="img.dialog"
                   :width="dw">
            <div class="demo-image">
              <el-image
                style="width: 100%; max-width: 100%; height: 100%;"
                :src="img.url"
                fit="cover" lazy>
                  <div slot="placeholder" class="image-slot">
                    <i class="el-icon-loading"></i> 開啟中...
                  </div>
                </el-image>
            </div>
         </el-dialog>
      

  </el-row>


</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import {mapState} from 'vuex'
import debounce from 'lodash/debounce'
import dayjs from "dayjs";

export default {
  name: "ReqBuyPage",
  components: {
    Breadcrumb
  },
  data() {
    let checkName = (rule, value, callback) => {
        if (value === '' || value === null) {
          callback(new Error('請輸入資料'))
        } else {
          callback()
        }
      }
      let checkRadio = (rule, value, callback) => {
        console.log("checkRadio:", rule, value)
        if (value === '' || value === null) {
          callback(new Error('請選擇同意或退回'))
        } else {
          callback()
        }
      }

    return {
      img:{
        dialog: false,
        url:''
      },

      dw: '50%',
      signoff:{
        dialog: false,
        notes: '',
        rules: {
          signResult: [{required: true, validator: checkRadio, trigger: 'change'}]
        }
      },
      job:{
        id:'',
        jobInfo:{
          id:'',
          alreadySigned:'no'
        },
        todoInfo:{
          userObj:{}
        },
        divMgrHistory:[],
        customerHistory:[],
        signoffHistory:[],
        reqBuyHistory:[],
        reqItemHistory:[]
      },
    }
  },
  computed: {
    ...mapState('login', ['userInfo'])
  },
  methods: {
    showImage(uuid) {
      this.img.dialog = true
      this.img.url = this.displayAvatar(uuid)
    },
    
    subTotalCalculate() {

      let qty = this.task.form.itemQty
      let price = this.task.form.itemPrice
      this.task.form.itemSubTotal = qty * price

      console.log('subTotalCalculate:', this.task.form.itemSubTotal)

    },
    closeTaskDialog() {
      //this.task.form.notes = ''
      this.$refs['taskForm'].resetFields()
      this.task.btnCount = 0
      //this.loadCustomerHistoryData()
    },
    taskHandleUploadSuccess(res, file) {
      this.task.form.fileList.push(res.uuid)
    },
    taskNewUploadField() {
      this.task.btnCount++
    },
    taskHandleFileRemove(file, fileList) {
      this.task.form.fileList = this.task.form.fileList.filter(e => e !== file.response.uuid)
    },
    taskFormSave(formName){
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            this.request.post("/todo/req-buy/history", this.task.form).then(res => {
              if (res.code === '200') {
                this.task.dialog = false
                this.taskLoadHistory()
                this.showResult('success', '新增成功')
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })
    },
    loadTaskType() {
      let req = '/dic/type?queryField=sales_manager_task'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.task.taskTypeOptions = res.data
        }
      })
    },
    handleAddTask() {
      this.task.dialog = true
      this.task.form.id = null
      this.task.form.fileList = []
      this.task.form.fileNotes = []
      this.task.btnCount = 0
    },  
    taskHandleDeleteHistory(id) {
      this.request.delete("/todo/req-buy/history/" + id).then(res => {
        if (res.code === '200') {
          this.taskLoadHistory()
          this.showResult('success', '資料刪除成功.')
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },
    taskLoadHistory() {
      this.request.get("/todo/req-buy/history/" + this.task.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.task.tableData = res.data

          
          // let initPrice = 0
          // this.task.tableData.forEach(obj => {
          //   initPrice += parseInt(obj.itemSubTotal)
          // })
          // //產品加總
          // this.task.form.itemSum = initPrice

          

          this.recalculate()
        } else {
          this.showResult('error', '工作項目紀錄撈取失敗')
        }
      })
    },
    recalculate(){
      let itemSum = this.task.form.itemSum
      let tax = 0
      if(this.task.form.tax === 1) {
        tax = 0.05
      }
      this.task.form.taxPrice = Math.round(itemSum * tax)
      this.task.form.totalPrice = parseInt(itemSum) + parseInt(this.task.form.taxPrice)
    },

    //參數為勾選的值，array
    handleDeliveryChange(selectedItem){
      console.log(selectedItem)
      console.log(selectedItem.includes('指送'))
      if (selectedItem.includes('指送')) {
        this.shippingToDifferentAddress = true
      } else {
        this.shippingToDifferentAddress = false
      }
    },
    handleSelect(item) {
      this.form.custId = item.id
    },
    querySearch(str, cb){
      this.request.get("/customer/q?keyword=" + str).then(res => {
        if (res.code === '200') {
          let list = res.data.map((item) => {
            return {
              value: item.company + "(" + item.name + ")",
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleClose(tag) {
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
    showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    loadCustomerHistoryData() {
      this.request.get("/todo/customer/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.tableData = res.data
        } else {
          this.showResult('error', '客戶拜訪紀錄撈取失敗')
        }
      })
    },
    loadJobSignHistory() {
      this.request.get("/job/signoff/history/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.historyTableData = res.data
        } else {
          this.showResult('error', '客戶拜訪簽核紀錄撈取失敗')
        }
      })
    },
    async saveData(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('this.form:', this.form)
        if (valid) {
          try {
            await this.$store.dispatch('todo/saveMytodo', this.form)

            this.showResult('success', '資料更新成功.')

            await this.loadCustomerHistoryData()
            this.dialogFormVisible = false

          } catch (e) {
            this.showResult('success', '資料更新失敗')
          }
        }
      })
    },
    handleSubmitForm() {
      this.request.post("/todo", this.basicForm).then(res => {
        //console.log(res)
        if (res.code === '200') {
          this.formDefault()
          this.showResult('success', '資料更新成功.')
        } else {
          this.showResult('error', '資料更新失敗.')
        }
      })
    },
    handleDraft() {

      this.basicForm.itemSum = this.task.form.itemSum
      this.basicForm.tax = this.task.form.tax
      this.basicForm.taxPrice = this.task.form.taxPrice
      this.basicForm.totalPrice = this.task.form.totalPrice

      this.handleSubmitForm()
    },
    handleSign() {
      this.signoff.dialog = true
      this.signoff.notes = ''
    },
    handleInvalid(id) {
      this.request.post("/todo/invalid/" + id).then(res => {
          if (res.code === '200') {
            this.$router.go()
            this.showResult('success', '資料作廢成功.')
          } else {
            this.showResult('error', '資料作廢失敗.')
          }
      })
    },
    handleAdd() {
      this.dialogFormVisible = true
      this.form.id = null
      this.form.fileList = []
      this.form.fileNotes = []
      this.btnCount = 0
    },
    handleEdit(rowData) {
      this.dialogFormVisible = true
      this.form = rowData
    },
    handleDelete(id) {
      this.request.delete("/todo/customer/history/" + id).then(res => {
        if (res.code === '200') {
          this.showResult('success', '資料刪除成功.')
          this.loadCustomerHistoryData()
        } else {
          this.showResult('error', '資料刪除失敗.')
        }
      })
    },

    closeDialog() {
      this.form.notes = ''
      this.$refs['visitForm'].resetFields()
      //this.loadCustomerHistoryData()
    },
    setDialogWidth() {
      let windowSize = document.body.clientWidth;
      const defaultWidth = 400; // 預設寬度
      if (windowSize < defaultWidth) {
        this.dw = "90%";
      } else {
        this.dw = "60%"
      }
    },
    formDefault() {
      this.request.get("/todo/" + this.form.mytodoId).then(res => {
        if (res.code === '200') {
          this.basicForm = res.data

          this.task.form.itemSum = res.data.itemSum
          this.task.form.tax = res.data.tax
          this.task.form.taxPrice = res.data.taxPrice
          this.task.form.totalPrice = res.data.totalPrice


          


        } else {
          this.showResult('error', '撈資料失敗')
        }
      })
      this.form.userId = this.userInfo.id
      this.form.todoType = this.getTodoType()
    },
    getTodoType() {
      this.userInfo.id;
    },
    loadPreCheckItem() {
      let req = '/dic/type?queryField=pre_check'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.preCheckOption = res.data
        }
      })
    },
    goBack() {
      this.$router.push('/message/my-signoff')
    },
    handleUploadSuccess(res, file) {
      this.form.fileList.push(res.uuid)
    },
    handleFileRemove(file, fileList) {
      this.form.fileList = this.form.fileList.filter(e => e !== file.response.uuid)
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      return isLt5M
    },
    saveCustomerVisit(formName) {
      this.$refs[formName].validate(async valid => {
        console.log('valid:', valid)
        if (valid) {
          try {
            //將陣列轉換成後台可以接的字串
            this.form.deliveryContent = this.form.deliveryContentChecked.join(",")
            this.form.serviceContent = this.form.serviceContentChecked.join(",")
            this.form.paymentReceive = this.form.paymentReceiveChecked.join(",")
            this.request.post("/todo/customer/history", this.form).then(res => {
              if (res.code === '200') {
                this.dialogFormVisible = false
                this.loadCustomerHistoryData()
                this.showResult('success', '新增成功')
              } else {
                this.showResult('error', res.message)
              }
            })

          } catch (e) {
            this.showResult('error', '資料更新失敗')
          }
        }
      })

    },
    loadMyCustomer() {
      this.request.get("/customer/query1?keyword=&all=y").then(res => {
        if (res.code === '200') {
          this.options = res.data
        } else {
          this.options = ['查無負責的客戶名稱']
        }
      })
    },
    newUploadField() {
      this.btnCount++
    },
    findJobContent() {
      this.request.get("/job/detail/" + this.job.id).then(res => {
        if (res.code === '200') {
          this.job = res.data
        }
      })
    },
    sendSignoff(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.request.post("/job", this.job.jobInfo).then(res => {
            if (res.code === '200') {
              this.showResult('success', '完成簽核')
              this.signoff.dialog = false
              this.$router.push('/message/my-signoff')
            } else {
              this.showResult('error', '簽核結果儲存失敗')
            }
          })
        }
      })
    },
  },
  filters: {
    signResult(value) {
      if (value === 'N') return '退回'
      if (value === 'Y') return '同意'
      if (value === 'cancel') return '取消'
      if (value === 'invalid') return '作廢'
    }
  },
  mounted() {
    this.job.id = this.$route.params.jobId

    this.findJobContent()
    

    this.setDialogWidth();



  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.el-table >>> .headerStyle {
  /*background-color: #1e8fc6;*/
}

.el-popover.el-popper .el-popconfirm {
  background-color: black !important;
  padding: 10px !important;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.display-avatar {
  width: 60px;
  height: 60px;
  border-radius: 999px;
}


/deep/ .el-upload-dragger {
  width: 180px !important;
}

.el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }

.myform >>> .el-form-item__label {
  padding: 0;
}

.el-main {
  padding: 0;
}
.el-form-item {
  margin-bottom: 12px;
}

.taskMain >>> .el-card__body {
  padding: 0;
}
.el-table {
  padding: 0;
}

.mymain >>> .el-card__body {
  padding: 0;
}
.mycard >>> .el-col {
  height: 30px;
}
</style>
